import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import { navigate } from '@reach/router';
import PropTypes from 'prop-types';
import lazyImages from '../../utils/lazyImages';
import Layout from '../../components/Layout/Layout';
import SEO from '../../components/SEO/SEO';
import { switchLangUrls } from '../../utils/switchLangUrls';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Post from './sections/Post';
import './page.scss';

export function Article({
  data, posts, menu, topBanner, footer, otherProps
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(lazyImages, 100);
  });

  const setTag = (tag) => {
    const cat = typeof tag === 'string' || '' ? tag : tag.target.dataset.tag;
    const { lang } = tag.target.dataset;
    navigate(`/${lang}/blog`, { state: { cat } });
  };

  const changeLang = (lang) => {
    switchLangUrls(lang, data, otherProps);
  };

  return (
    <main id="p-blog">
      <SEO data={data} post />
      {typeof window !== 'undefined' &&
        <div>
          <Header menu={menu} content={data.acf} topBanner={topBanner} lang={data.polylang_current_lang} otherProps={otherProps} />
          <Post post={data} posts={posts} setTag={setTag} />
          <Footer footer={footer} langs={data} changeLang={(e) => changeLang(e, data, otherProps)} lang={data.polylang_current_lang} />
        </div>}
    </main>
  );
}

const Page = (props) => {
  const {
    wordpressPost: post, allWordpressPost: posts, allWordpressPage: headerAndFooter, wordpressMenusMenusItems: menu
  } = props.data;
  return (
    <Layout props={props}>
      <Article data={post} posts={posts} menu={menu} topBanner={headerAndFooter} footer={headerAndFooter} otherProps={{ ...props }} />
    </Layout>
  );
};

Page.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Page;

export const pageQuery = graphql`
  query Post($lang: String, $id: Int, $menuLangName: String) {
    wordpressMenusMenusItems(
      name: {eq: $menuLangName}
    ) {
      items {
        url
        title
        classes
      }
      name
    }
    allWordpressPage {
      edges {
        node {
          polylang_current_lang
          acf {
            head_script
            top_banner_text_color
            top_banner_message
            top_banner_background_color
            show_top_banner
            footer_col_1
            footer_col_2
            footer_col_3
            footer_col_4
            footer_horizontal_menu
            store_google_url
            store_apple_url
            store_apple_image {
              source_url
            }
            store_google_image {
              source_url
            }
            social_media_item_page {
              image {
                source_url
              }
              url
            }
          }
        }
      }
    }
    allWordpressPost(filter: {polylang_current_lang: { eq: $lang }}) {
      edges {
        node {
          title
          date
          content
          slug
          polylang_current_lang
          wordpress_id
          categories {
            name
          }
          featured_media {
            source_url
          }
          acf {
            logo
          }
        }
      }
    }
    wordpressPost(
      wordpress_id: { eq: $id },
      polylang_current_lang: { eq: $lang }
    ) {
      polylang_current_lang
      title
      date
      content
      excerpt
      slug
      wordpress_id
      featured_media {
        source_url
      }
      categories {
        name
      }
      polylang_translations {
        slug
        polylang_current_lang
      }
      yoast {
        metadesc
        title
      }
      acf {
        logo
        faq_post {
          answer
          question
        }
        cta_button_url
        cta_button_text
      }
    }
  }
`;
